import { useEffect, useState } from 'react';
// Service
import InventoryService from '../../services/inventoryService';
// Hooks
import useUser from '../../hooks/user/useUser';

const initialfilters = {
    pageSize: 10,
    pageNumber: 1
}

const useInventory = ( filters = initialfilters ) => {
    const { branch: { warehouseId } } = useUser();
    const [searchResult, setSearchResult] = useState({ stocks: [], totalPage: 1, totalResults: 0 });
    const [loading, setLoading] = useState(false);
    const [categories, setCategories] = useState([]);
    const [activeRequests, setActiveRequests] = useState(0);

    useEffect(() => {
        const abortController = new AbortController();

        const SearchInventory = async () => {
            setLoading(true);
            setActiveRequests((prev) => prev + 1);

            const req = { 
                ...filters, 
                warehouseIds: [warehouseId],
                categoryIds: categories,
                skus: filters?.skus 
                    ? filters.skus.toString().split(',').map(s => s.trim()) || null 
                    : null,
                moreOrEqualTo: filters?.moreOrEqualTo ? Number(filters?.moreOrEqualTo) : null,
                lessOrEqualTo: filters?.lessOrEqualTo ? (-1) * Number(filters?.lessOrEqualTo) : null,
            };

			await InventoryService
                .Search(req, { signal: abortController.signal })
                .then(res => setSearchResult({
                    stocks: res.values, 
                    totalResults: res.totalResults, 
                    totalPage: res.totalPage
                }))
                .finally(() => {
                    setActiveRequests((prev) => {
                      const newCount = prev - 1;
                      if (newCount === 0) {
                        setLoading(false);
                      }
                      return newCount;
                    });
                  });
        }
        
        if(warehouseId)
            SearchInventory();
        
        return () => {
            abortController.abort();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filters, warehouseId, categories])

    return {
        ...searchResult,
        loading,
        filters,
        categories,
        setCategories
    }
}

export default useInventory;